export default __webpack_public_path__ + "static/media/type-31.639c40ad.jpg";